var search = {
	selectors: {
		listing: '.ajax-search-results:not( ajax-search-results--inline )'
	},

	init: function () {
		var self = this;

		jQuery( document ).on( 'keyup', 'input[name="s"]', function( event ) {
			if ( event.key === "Escape" || event.keyCode === 27 ) {
				self.closeAjaxWindow();
				return false;
			}

			var searchBox 	= jQuery( this );
			var searchQuery = searchBox.val();
			var resultsBox 	= jQuery( self.selectors.listing );

			searchBox.addClass( 'loading-search' );
			jQuery( 'body' ).addClass( 'search-open' );
	
			jQuery.ajax({
				url: sikmoVars.ajax_url,
				type: 'GET',
				data: {
					action: 'ajax_search',
					query: searchQuery
				},
				success: function(response) {
					searchBox.removeClass( 'loading-search' );
					resultsBox.removeClass( 'd-none' );
					resultsBox.html( response.data.html );
				}
			});
		});

		jQuery(document).mousedown(function(event) {
			if ( ! jQuery( event.target ).closest( self.selectors.listing ).length) {
				self.closeAjaxWindow();
			}
		});
	},

	closeAjaxWindow: function() {
		var self = this;

		if( ! jQuery( 'body' ).hasClass( 'search-open' ) ) {
			return false;
		}

		var resultsBox 	= jQuery( self.selectors.listing );
		resultsBox.addClass( 'd-none' );
		jQuery( 'body' ).removeClass( 'search-open' )
	},
};

export { search };